import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import Content from './Content';
import './Frame.css';
import Navbar from './NavBar/NavBar';
import AuthContent from '../../Auth/AuthContent';
import { Loading } from '../../_common';
import { useStoreContext } from '../StoreProvider';
import moment from 'moment-timezone';
import { Routes } from '../../../utils';

const Frame: FC = () => {
    const [state] = useStoreContext();
    const { pathname } = useLocation();
    const isLoadsPage = pathname.startsWith(Routes.LOAD_MANAGEMENT.route);
    const { auth } = state;
    moment.tz.setDefault('America/Chicago');

    if (auth.isUserLoading) {
        return (
            <span className="Frame-Loading">
                <Loading />
            </span>
        );
    }

    if (auth.user && !auth.user.expired) {
        return (
            <div className={`Frame-Container${isLoadsPage ? ' Frame-Container--loads' : ''}`}>
                <div className="Frame-Navigation">
                    <Navbar />
                </div>
                <div className={`Frame-Content${isLoadsPage ? ' Frame-Content--loads' : ''}`}>
                    <Content />
                </div>
            </div>
        );
    } else {
        return <AuthContent />;
    }
};

export default Frame;
